/* global messg */
import I18n from 'lib/i18n'

import React from 'react'
import { useValues, useActions } from 'kea'

import Button from 'lib/tags/button'

import sceneLogic from '../../logic'
import sceneForm, { Field } from '../../form'

export default function Student () {
  const { inviteBonusClass, inviteBonusTeach, personalInvitationUrl, dpr, facebookApp } = useValues(sceneLogic)
  const {
    isSubmitting,
    hasErrors,
    formValues: { emailList }
  } = useValues(sceneForm)
  const { submit } = useActions(sceneForm)

  const finalDpr = typeof window !== 'undefined' ? window.devicePixelRatio || dpr : dpr
  const isRetina = finalDpr >= 2

  const shareFacebook = e => {
    e.preventDefault()
    let url = `https://www.facebook.com/dialog/feed?app_id=${facebookApp}&display=popup&link=${encodeURIComponent(
      personalInvitationUrl
    )}`

    window.open(url, 'share-facebook', 'toolbar=0,status=0,width=600,height=436')
  }

  const shareTwitter = e => {
    e.preventDefault()
    window.open(
      'https://twitter.com/share?url=' +
        encodeURIComponent(personalInvitationUrl) +
        '&text=' +
        encodeURIComponent(I18n.t('invites.show.tweet')),
      'share-linkedin',
      'toolbar=0,status=0,width=600,height=436'
    )
  }

  const copyLink = e => {
    e.preventDefault()
    try {
      // auto copy
      navigator.clipboard.writeText(personalInvitationUrl).then(() => {
        messg.success(I18n.t('courses.show.link_copied'), 1500)
      })
    } catch (error) {
      // just display url to copy
    }
  }

  let emailCount = emailList.length < 3 ? 3 : emailList.length
  if (emailList.length > 0 && emailList[emailList.length - 1].trim()) {
    emailCount += 1
  }

  return (
    <div className='content-page media-page'>
      <div className='row'>
        <div className='twelve columns'>
          <div className='invite-form'>
            <h5>{I18n.t('pages.invite.student.heading')}</h5>
            <p className='special-text'>
              {I18n.t('pages.invite.student.subheading', {
                invite_bonus_class: inviteBonusClass,
                invite_bonus_teach: inviteBonusTeach
              })}
            </p>
            <strong>{I18n.t('pages.invite.student.text_1')}</strong>
            <p>
              {I18n.t('pages.invite.student.text_2')}
              <br />
              {I18n.t('pages.invite.student.text_3')}
            </p>
            <div className='form'>
              <div className='left'>
                <strong className='strong-title'>{I18n.t('pages.invite.student.enter_emails')}</strong>
                <div>
                  {[...Array(emailCount)].map((_, i) => (
                    <Field name='emailList' id={i} key={i}>
                      {({ value, setTargetValue }) => (
                        <div className='email-input' key={`${i}-email-input`}>
                          <strong>{`${i + 1}.`}</strong>
                          <input
                            type='text'
                            className='input-text'
                            value={value || ''}
                            placeholder={I18n.t('pages.invite.student.friend_mail')}
                            onChange={setTargetValue}
                          />
                        </div>
                      )}
                    </Field>
                  ))}

                  <Button
                    color='white'
                    backgroundColor='green'
                    className='submit-emails-button'
                    onClick={submit}
                    isSubmitting={isSubmitting}
                    disabled={isSubmitting}
                    isStyleDisabled={hasErrors}
                    content={I18n.t('pages.invite.student.send_invites')}
                    dataAttr='book-button'
                  />
                </div>
              </div>
              <div className='right'>
                <strong className='strong-title'>{I18n.t('pages.invite.student.share_link')}</strong>
                <input
                  data-attr='invite-link'
                  className='link-to-copy-input'
                  onFocus={copyLink}
                  onChange={() => {}}
                  value={personalInvitationUrl}
                />
                <strong className='strong-title'>{I18n.t('invites.index.share')}</strong>
                <div className='big-padding'>
                  <a className='facebook' href='#' onClick={shareFacebook}>
                    <img
                      src={
                        isRetina
                          ? '/assets/social-flat/64/facebook-squared.png'
                          : '/assets/social-flat/32/facebook-squared.png'
                      }
                      alt='Facebook'
                      width='32'
                      height='32'
                      style={{ borderRadius: 2 }}
                    />
                  </a>
                  <a className='twitter' href='#' onClick={shareTwitter}>
                    <img src='/assets/design/social-media-icons/x-twitter.svg' alt='Twitter' height='32' width='32' />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
